import Vue from 'vue'
import { createImage} from '~image'
import NuxtImg from '~image/components/nuxt-img.vue'
import NuxtPicture from '~image/components/nuxt-picture.vue'

import * as staticRuntime$fe83 from '/var/www/ct-frontend/ct-front-20261029043307/node_modules/@nuxt/image/dist/runtime/providers/static.js'
import * as imageProviderRuntime$cada from '/var/www/ct-frontend/ct-front-20261029043307/providers/imageProvider.js'
import * as imageProviderTranportationRuntime$cada from '/var/www/ct-frontend/ct-front-20261029043307/providers/imageProvider.js'

const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageProvider",
  "domains": [],
  "alias": {}
}

imageOptions.providers = {
  ['static']: { provider: staticRuntime$fe83, defaults: {} },
  ['imageProvider']: { provider: imageProviderRuntime$cada, defaults: {"modifiers":{"format":"webp"},"screens":{"xs":320,"sm":640,"md":768,"lg":1024,"xl":1200},"baseURL":"https://centraltrans.ru/api/storage/image/"} },
  ['imageProviderTranportation']: { provider: imageProviderTranportationRuntime$cada, defaults: {"modifiers":{"format":"webp"},"screens":{"xs":320,"sm":640,"md":768,"lg":1024,"xl":1200},"baseURL":"https://transportation-api.centraltrans.ru/api/storage/image/"} }
}

Vue.component(NuxtImg.name, NuxtImg)
Vue.component(NuxtPicture.name, NuxtPicture)
Vue.component('NImg', NuxtImg)
Vue.component('NPicture', NuxtPicture)

export default function (nuxtContext, inject) {
  const $img = createImage(imageOptions, nuxtContext)

  if (process.static && process.server) {
    nuxtContext.beforeNuxtRender(({ nuxtState }) => {
      const ssrData = nuxtState.data[0] || {}
      ssrData._img = nuxtState._img || {}
    })
  }

  inject('img', $img)
}
